export default class Symbol {
  /*
    Util class for symbol operations
    */

  constructor(symbol) {
    this.symbol = symbol;
  }

  encode() {
    /*
        Replaces characters that are not allowed in the URL
        with equivalents.
        The equivalents are matched in the backend
        */
    this.symbol = this.symbol.replace('/', '-forwardslash-');
    this.symbol = this.symbol.replace('.', '-period-');
    this.symbol = this.symbol.replace(' ', '-space-');
    this.symbol = this.symbol.replace('*', '-asterisk-');
    return this.symbol;
  }

  decode() {
    /*
        Opposite of encode() above
        */
    this.symbol = this.symbol.replace('-forwardslash-', '/');
    this.symbol = this.symbol.replace('-period-', '.');
    this.symbol = this.symbol.replace('-space-', ' ');
    this.symbol = this.symbol.replace('-asterisk-', '*');
    return this.symbol;
  }
}
